var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.083 21.908c.368-.196.586-.668.537-1.157l-.596-5.862H17.3c.17 0 .355 0 .508-.017.142-.016.45-.06.721-.329.302-.3.476-.755.47-1.233a1.85 1.85 0 0 0-.256-.892 7 7 0 0 0-.315-.49l-.019-.028-6.439-9.5c-.257-.38-.686-.504-1.054-.308s-.586.668-.537 1.157l.596 5.862H6.7c-.17 0-.355 0-.508.017-.143.016-.45.06-.721.329-.302.3-.476.755-.47 1.233.005.428.175.747.256.892a7 7 0 0 0 .334.518l6.439 9.5c.257.38.686.505 1.054.308m-5.66-10.575H12c.26 0 .506-.136.678-.375.171-.24.25-.557.219-.874l-.34-3.35 4.02 5.933H12c-.26 0-.506.136-.678.375a1.3 1.3 0 0 0-.219.874l.34 3.35z",
    clipRule: "evenodd"
  })));
};
export default SvgLightning;